const AUTH_SERVER_URL = 'https://auth.documedias.com/';

// Production
const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxNzg2LCJjb25ncmVzc0lkIjoxNDA1LCJkYXRlIjoiMjAyMy0wMi0yMFQwNzoxMjozMy4wMzVaIiwiaWF0IjoxNjc2ODc3MTUzfQ.glYGQFoghvR1pFAw9pmcDel9gd87ia_boLCbNpy5FJI';
const PLANNER_API_URL = 'https://ueg2023.planner.documedias.systems/api';

// Development
// const AUTH_SERVER_FRONTEND_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjoxNzg3LCJjb25ncmVzc0lkIjoxNDA1LCJkYXRlIjoiMjAyMy0wMi0yMFQwNzoxMzowOS4zMzNaIiwiaWF0IjoxNjc2ODc3MTg5fQ.CP2905GQ0cyYXUr9pNCV3mHUl_dZvBMXLJtfTex2ttY';
// const PLANNER_API_URL = 'http://localhost:8000/api';

const CONGRESS_ID = 1405;
const SUBMISSION_API_URL = 'https://ueg2023.abstract.documedias.systems/api/v1/manager/abstract/multi/html/id/{{id}}/template/planner_preview';

const SESSION_GROUP_ID = 9;

export {
  AUTH_SERVER_URL,
  AUTH_SERVER_FRONTEND_KEY,
  PLANNER_API_URL,
  CONGRESS_ID,
  SUBMISSION_API_URL,
  SESSION_GROUP_ID,
}
